import { observer } from 'mobx-react'
import { FC } from 'react'
import TransactionList from './TransactionList'
import useTransactions from '../../../hooks/api/useTransactions'
import { isTransactionClosed } from 'src/services/transactions/status'

const Transactions_closed: FC<unknown> = () => {
  const hook = useTransactions(true)
  const { data: transactionsPayload } = hook

  const closedTransactions = transactionsPayload?.data.filter(isTransactionClosed)
  return (
    <TransactionList
      {...hook}
      transactions={closedTransactions || []}
      withMutationOptions={false}
    />
  )
}

export default observer(Transactions_closed)
